import React from 'react';
import { Sparkles, Check } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { ColorImage } from './ColorImage';

export const ColorCard = ({ color, selectMode, selected, onSelect, onOpen }) => {
  const handleClick = () => (selectMode ? onSelect(color.id) : onOpen(color));
  const id = color.id || color.source_color_id;

  return (
    <Card
      data-testid={`color-card-${id}`}
      className={`group cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden ${
        selected ? 'ring-2 ring-amber-500' : ''
      }`}
      onClick={handleClick}
    >
      <div className="relative aspect-square">
        <ColorImage
          src={color.room_visualization_url || color.ai_visualization_url || color.image_url}
          alt={color.name}
          hex={color.hex_color}
          className="w-full h-full"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          {!selectMode && <Sparkles className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" />}
        </div>

        {selectMode && (
          <div
            data-testid={`color-card-checkbox-${id}`}
            className={`absolute top-2 left-2 w-6 h-6 rounded-md border-2 flex items-center justify-center transition-colors ${
              selected ? 'bg-amber-500 border-amber-500' : 'bg-white/90 border-neutral-300'
            }`}
          >
            {selected && <Check className="w-4 h-4 text-white" />}
          </div>
        )}

        {color.image_url && (
          <div
            className="absolute bottom-2 left-2 w-7 h-7 rounded-md border-2 border-white shadow-md overflow-hidden bg-neutral-200"
            title="Fabric swatch"
            data-testid={`color-card-swatch-${id}`}
          >
            <ColorImage src={color.image_url} alt={`${color.name} swatch`} hex={color.hex_color} className="w-full h-full" />
          </div>
        )}
        <div
          className="absolute bottom-2 right-2 w-6 h-6 rounded-full border-2 border-white shadow-md"
          style={{ backgroundColor: color.hex_color || '#ccc' }}
        />
      </div>
      <CardContent className="p-3">
        <h3 className="font-medium text-sm truncate" title={color.name}>{color.name}</h3>
        <p className="text-xs text-neutral-500 truncate">{color.collection_name}</p>
        <div className="flex items-center gap-1 mt-1">
          <Badge variant="secondary" className="text-[10px] px-1.5 py-0">{color.brand_name}</Badge>
        </div>
      </CardContent>
    </Card>
  );
};

export default ColorCard;
